import { IAnalyticsRepository, IAnalyticsShareLink } from "@/core/repositories/analytics";

export class GetAnalyticsShareLinkUseCase {
  constructor(private readonly repo: IAnalyticsRepository) {}

  async execute(): Promise<IAnalyticsShareLink> {
    return this.repo.getAnalyticsShareLink();
  }
}
